import { render } from "./DeleteGalleryConfirmationModalComponent.vue?vue&type=template&id=c2c75902&ts=true"
import script from "./DeleteGalleryConfirmationModalComponent.vue?vue&type=script&lang=ts"
export * from "./DeleteGalleryConfirmationModalComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__